<template>
  <main>
    <div class="header-a">
      <img src="../assets/img/car.png" alt="" />
    </div>
    <div class="msg">
      <!-- <div class="num">500/600</div> -->
      <div>
        <span class="b">{{ carInfo.name }}</span>
      </div>

      <div class="a">
        <p>{{ carInfo.location }}</p>
      </div>
      <div class="navigation">导航</div>
      <div class="list">
        <div>
          <h3>负责人</h3>
          <p>{{ carInfo.person }}</p>
        </div>
        <div>
          <h3>联系电话</h3>
          <p>{{ carInfo.telephone }}</p>
        </div>
        <div>
          <h3>总车位</h3>
          <p>{{ carInfo.lotCount }}</p>
        </div>
        <div>
          <h3>剩余车位</h3>
          <p>{{ carInfo.lotFree }}</p>
        </div>
      </div>
      <p></p>
    </div>
  </main>
</template>

<script>
import API from "../api/index";

export default {
  name: "carinfo",
  data() {
    return {
      carInfo: [],
    };
  },

  mounted() {
    var that = this;
    var movieId = that.$route.params.id;
    console.log(movieId);
    this.$http({
      method: "get",
      params: {
        id: movieId,
      },
      url: API.parksGetById_url,
    })
      .then(function (resp) {
        console.log(resp.data);
        that.carInfo = resp.data.data;
      })
      .catch((resp) => {
        console.log("请求失败：" + resp.status + "," + resp.statusText);
      });
  },
  methods: {
    link(url) {
      this.$router.push(url);
    },
  },
};
</script>

<style scoped>
.header-a {
  padding: 0 30px;
}

.header-a img {
  width: 100%;
  height: 100%;
  
border-radius: 10px;
}


.msg {
  margin: 0px 30px;
  background: #fff;

  box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

.b {
  font-size: 40px;
  color: #343434;
  margin: 0 20px;
}
.a {
  font-size: 30px;
  color: #666666;
  margin: 10px 20px;
  width: 500px;
}

.c {
  float: right;
  color: #666666;
  font-size: 22px;
}

.navigation {
  float: right;
  background: #38c292;
  color: #fff;
  text-align: center;
  line-height: 60px;
  width: 100px;
  height: 60px;
  border-radius: 5px;
  margin: 0 20px;
}

.list div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 500px;
  height: 50px;
  padding: 0 30px;
}

.list div h3 {
  font-size: 30px;
  color: #333333;
}

.list div p {
  font-size: 30px;
  color: #333333;
}
</style>>




// WEBPACK FOOTER //
// src/pages/carinfo.vue